import { AISummaryPanel } from "@/shared/components/ai";
import { useDatasetSummary } from "@/shared/domain/datasets/hooks/useDatasetSummary";
import { useGenerateDatasetSummary } from "@/shared/domain/datasets/hooks/useGenerateDatasetSummary";

import { useDatasetContext } from "../useDatasetContext";

export function DatasetAISummary() {
  const { datasetId } = useDatasetContext();
  const { data, isLoading, isError } = useDatasetSummary(datasetId);
  const generate = useGenerateDatasetSummary();

  return (
    <AISummaryPanel
      summary={data}
      isLoading={isLoading}
      isLoadError={isError}
      isGenerating={generate.isPending}
      isGenerateError={generate.isError}
      onGenerate={() => generate.mutate({ datasetId })}
      subject={{ type: "dataset", id: datasetId }}
    />
  );
}
